export default __webpack_public_path__ + "static/media/perbandingan-bottomry-respondia-dengan-asuransi-modern.f3a9ca77.png";